<template>
  <transition name="msgbox-fade">
    <div
      class="message-box__wrapper"
      tabindex="-1"
      v-show="visible"
      @click.self="handleWrapperClick"
      role="dialog"
      aria-modal="true"
      :aria-label="title || '系统提示'"
    >
      <div
        class="message-box"
        :class="[ center && 'message-box--center']"
      >
        <div
          class="message-box__header"
          v-if="title !== null"
        >
          <div class="message-box__title">
            <span>{{ i18n.t(title) }}</span>
          </div>
          <button
            type="button"
            class="message-box__headerbtn"
            aria-label="Close"
            v-if="showClose"
            @click="handleAction('close')"
            @keydown.enter="handleAction('close')"
            @mouseover="handleIconHover(true)"
            @mouseout="handleIconHover(false)"
          >
            <svg
              class="icon"
              aria-hidden="true"
            >
              <use :xlink:href="hoverIcon"></use>
            </svg>
          </button>
        </div>
        <div class="message-box__content">
          <div class="message-box__container">
            <div
              :class="['message-box__status', icon]"
              v-if="icon && !center && message !== ''"
            >
            </div>
            <div
              class="message-box__message"
              v-if="message !== ''"
            >
              <slot v-if="!dangerouslyUseHTMLString">
                <p>{{ i18n.t(message) }}</p>
              </slot>
              <slot v-else>
                <div v-html="message"></div>
              </slot>
            </div>
          </div>
        </div>
        <div class="message-box__btns">
          <el-button
            :loading="confirmButtonLoading"
            ref="confirm"
            :class="[ confirmButtonClasses ]"
            v-show="showConfirmButton"
            :round="roundButton"
            size="small"
            @click.native="handleAction('confirm')"
            @keydown.enter="handleAction('confirm')"
          >
            {{ i18n.t(confirmButtonText) || i18n.t('el.messagebox.confirm') }}
          </el-button>
          <el-button
            :loading="cancelButtonLoading"
            :class="[ cancelButtonClasses ]"
            v-if="showCancelButton"
            :round="roundButton"
            size="small"
            @click.native="handleAction('cancel')"
            @keydown.enter="handleAction('cancel')"
          >
            {{ i18n.t(cancelButtonText) || i18n.t('el.messagebox.cancel') }}
          </el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script >
import i18n from '@/lang'
const typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
}
export default {
  props: {
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      default: true
    },
    closeOnHashChange: {
      default: true
    },
    center: {
      type: Boolean,
      default: true
    },
    roundButton: {
      type: Boolean,
      default: false
    },
    dangerouslyUseHTMLString: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18n,
      visible: false,
      uid: 1,
      title: undefined,
      message: '',
      type: '',
      iconClass: '',
      showConfirmButton: true,
      showCancelButton: false,
      confirmButtonText: '',
      cancelButtonText: '',
      action: '',
      confirmButtonLoading: false,
      cancelButtonLoading: false,
      iconHover: false
    }
  },
  computed: {
    icon () {
      const { type, iconClass } = this
      return iconClass || (type && typeMap[type] ? `el-icon-${typeMap[type]}` : '')
    },
    confirmButtonClasses () {
      return `el-button--primary ${this.confirmButtonClass}`
    },
    cancelButtonClasses () {
      return `${this.cancelButtonClass}`
    },
    hoverIcon () {
      return this.iconHover ? '#icon-guanbi2' : '#icon-guanbi1'
    }
  },
  methods: {
    getSafeClose () {
      const currentId = this.uid
      return () => {
        this.$nextTick(() => {
          if (currentId === this.uid) this.doClose('close')
        })
      }
    },
    doClose (action) {
      if (!this.visible) return
      this.visible = false
      this.callback(action)
    },
    handleWrapperClick () {
      if (this.closeOnClickModal) {
        this.handleAction('close')
      }
    },
    handleAction (action) {
      this.action = action
      if (typeof this.beforeClose === 'function') {
        this.close = this.getSafeClose()
        this.beforeClose(action, this, this.close)
      } else {
        this.doClose(action)
      }
    },
    handleIconHover (type) {
      this.iconHover = type
    }
  },
  watch: {
    visible (val) {
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.closeOnHashChange) {
        window.addEventListener('hashchange', this.close)
      }
    })
  },
  beforeDestroy () {
    if (this.closeOnHashChange) {
      window.removeEventListener('hashchange', this.close)
    }
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
